import React from 'react';
import {
  isPlatform,
  IonModal,
  IonContent,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonIcon
} from '@ionic/react';
import './LoadMap.scss';

export interface ILoadMapSatelliteProps {
  locationName: string;
  shipmentId: string;
  position?: any;
  showSatelliteMap: boolean;
  onDismissSatelliteMap: () => void;
}

export interface ILoadMapSatelliteState {
  isMapVisible: boolean;
  isShowMap: boolean;
}

export class LoadMapSatellite extends React.Component<
  ILoadMapSatelliteProps,
  ILoadMapSatelliteState
> {
  private readonly container = React.createRef<HTMLDivElement>();

  private map?: google.maps.Map;

  private readonly service?: google.maps.places.PlacesService;

  private infowindow?: google.maps.InfoWindow;

  constructor(props: ILoadMapSatelliteProps) {
    super(props);
  }

  public initMap = (): void => {
    if (!this.props.showSatelliteMap) {
      return;
    }
    this.infowindow = new google.maps.InfoWindow();
    if (this.container.current) {
      this.map = new google.maps.Map(this.container.current, {
        center: this.props.position,
        zoom: 18,
        mapTypeId: 'hybrid',
        mapTypeControl: false,
        streetViewControl: true,
        zoomControl: false,
        fullscreenControl: false
      });
    }
    this.createMarker(this.props.position);
  };

  createMarker = (pposition: any) => {
    const marker = new google.maps.Marker({
      map: this.map,
      position: pposition,
      icon: 'assets/images/destination.svg'
    });

    google.maps.event.addListener(marker, 'click', () => {
      if (this.infowindow) {
        this.infowindow.setContent(this.props.locationName);
        this.infowindow.open(this.map, marker);
      }
    });
  };

  timeOutFunc = () => {
    setTimeout(() => {
      this.initMap();
    }, 1000);
  };

  componentDidMount() {
    this.timeOutFunc();
  }

  componentDidUpdate(prevProps: ILoadMapSatelliteProps) {
    this.timeOutFunc();
  }

  render() {
    const isDesktop = isPlatform('desktop');
    const { shipmentId, showSatelliteMap, onDismissSatelliteMap } = this.props;

    return (
      <>
        <IonModal
          isOpen={showSatelliteMap}
          data-testid= "loadmap"
          onDidDismiss={() => onDismissSatelliteMap()}
          animated={false}
          cssClass={`${isDesktop ? 'satellite-view-desktop' : 'satellite-view-mobile'
            }`}
        >
          <IonContent fullscreen={isDesktop}>
            <IonToolbar className="satellite-toolbar">
              <IonButtons
                slot="end"
                onClick={() => {
                  onDismissSatelliteMap();
                }}
              >
                <IonIcon className="satellite-close" icon="close" />
              </IonButtons>
              <IonTitle className="satellite-title">{`${isDesktop ? 'Satellite view' : shipmentId
                }`}</IonTitle>
            </IonToolbar>

            <React.Fragment>
              <div
                style={{
                  height: '100%',
                  width: '100%',
                  translate: 'translate3d(0)',
                  opacity: 1,
                  position: 'relative'
                }}
                ref={this.container}
                className={'satellite-map'}
              />
            </React.Fragment>
          </IonContent>
        </IonModal>
      </>
    );
  }
}
